import { Component, OnInit } from '@angular/core';
import {UiService} from '../../services/ui-service/ui.service';
import {ApiService} from '../../services/api-service/api.service';

@Component({
  selector: 'app-header-mobile',
  templateUrl: './header-mobile.component.html',
  styleUrls: ['./header-mobile.component.scss']
})
export class HeaderMobileComponent implements OnInit {

  public phone: String;

  openSidebar = (event) => {
    this.UIservice.openSidebar(event);
    this.UIservice.shiftHeader(event);
    // this.UIservice.animateMain(event);

  }

  openRightMenu = (event) => {
    this.UIservice.toggleRightMenu(event);
  }

  shiftHeader = () => {
    let header = document.getElementsByTagName('header')[0];
    header.classList.toggle('--shifted');
  }

  constructor(private UIservice: UiService,private apiService: ApiService) {
    this.apiService.getSettings().subscribe(value => {
      this.phone = value['data'][0]['phone'];
    });
   
    this.UIservice.listenMobileHeaderShift().subscribe(value => {
      this.shiftHeader();
    });
  }

  ngOnInit() {
    
  }

}
